<template>
<div class="sync-detail" v-if="flag==index&&detailShow" v-cloak>
    <div class="sync-title" :class="itemSyncDetail.status=='Done'?'team-top':''">
       {{$t('language.popup.transferDetails')}}
    </div>
        <div v-if="itemSyncDetail.status=='Done'||(itemSyncDetail.status=='Normal'&&itemSyncDetail.result)" :class="itemSyncDetail.status=='Done'||(itemSyncDetail.status=='Normal'&&itemSyncDetail.result)?'team-top1':''">
            <div class="sync-all-line"  style="margin-top:10Px;">
                
              <span class="sync-column-left" v-if="showStatus(itemSyncDetail)=='threadSuccess'"> {{$t('language.common.result')}}:{{$t('language.common.success')}}
               
             </span>
               <span class="sync-column-left" v-if="showStatus(itemSyncDetail)=='threadFailure'">{{$t('language.common.result')}}:{{$t('language.common.failure')}}
               
             </span>
               <span class="sync-column-left" v-if="showStatus(itemSyncDetail)=='particalStatus'">{{$t('language.common.result')}}:{{$t('language.common.patial')}}
               
             </span>
               <span class="sync-column-left" v-if="showStatus(itemSyncDetail)=='threadCancel'">{{$t('language.common.result')}}:{{$t('language.common.canceled')}}
               
             </span>
          </div>
            <div class="sync-line">
           <span class="sync-column-left">{{$t('language.common.fileProcess')}}:
                 <span v-if="itemSyncDetail.lastLog">
                {{itemSyncDetail.lastLog.readyTranFileCount}}/{{itemSyncDetail.lastLog.totalFileCount}}
                </span>
            </span>
            </div>
        <div class="sync-line">
            <span class="sync-column-left">{{$t('language.common.dataProcess')}}:
            <span v-if="itemSyncDetail.lastLog">
                {{itemSyncDetail.lastLog.fileTotalReadedBytes|formatByte}}/{{itemSyncDetail.lastLog.totalBytes|formatByte}}
                </span> 
            </span>
            <span class="sync-column-right">{{$t('language.common.endTime')}}:
                <span >
                {{itemSyncDetail.lastLog|getEndTime}}
                </span>
            </span>
        </div>
        <div class="sync-line">
            <span class="sync-column-left">{{$t('language.common.startTime')}}: {{itemSyncDetail.lastLog.taskStartTimeStr}}</span>
            <span class="sync-column-right" >{{$t('language.common.executedTimes')}}: {{itemSyncDetail.runCount}}</span>
        </div>
        <div class="sync-line">
            <span class="sync-column-left" >{{$t('language.common.averageRateSpecial')}}: {{(itemSyncDetail.lastLog.fileTotalReadedBytes/(itemSyncDetail.lastLog.taskElaspedTimeLong/1000))|formatByteSpeed}}</span>
        </div>
 
    </div>
    <div class="sync-detail-two" v-else>
        <div class="sync-all-line">
            <span class="sync-column-left">{{$t('language.common.fileProcess')}}:
                <span v-if=" itemSyncDetail.syncDetail&&itemSyncDetail.syncDetail.state2.status!=0&&(itemSyncDetail.syncDetail.state2.readyTranFileCount||itemSyncDetail.syncDetail.state2.readyFindFileCount)">
                {{itemSyncDetail.syncDetail.state2.readyTranFileCount}}/{{itemSyncDetail.syncDetail.state2.readyFindFileCount}}
                </span>
            </span>
        </div>
        <div class="sync-line">
            <span class="sync-column-left">{{$t('language.common.dataProcess')}}:
                <span v-if=" itemSyncDetail.syncDetail.state2&&itemSyncDetail.syncDetail.state2.status!=0&&(itemSyncDetail.syncDetail.state2.readedBytes||itemSyncDetail.syncDetail.state2.totalBytes)">
                {{itemSyncDetail.syncDetail.state2.readedBytes|formatByte}}/{{itemSyncDetail.syncDetail.state2.totalBytes|formatByte}}
                </span>
            </span>
              
            <span class="sync-column-right">{{$t('language.popup.progress')}}:
                <span v-if="itemSyncDetail.syncDetail.state2&&itemSyncDetail.syncDetail.state2.percent">
               <span v-if="itemSyncDetail.syncDetail.state2.percent"> {{itemSyncDetail.syncDetail.state2.percent+'%'}}</span>
                <span v-if="!itemSyncDetail.syncDetail.state2.percent">0%</span>
                </span>
            </span>
        </div>
        <div class="sync-line">
            <span class="sync-column-left">{{$t('language.common.startTime')}}:<span v-if="itemSyncDetail.syncDetail.state2">{{itemSyncDetail.syncDetail.state2.taskStartTimeLong|transferTime}} </span></span>
            <span class="sync-column-right" >{{$t('language.common.currentRate')}}: <span v-if="itemSyncDetail.syncDetail.state2&&itemSyncDetail.syncDetail.state2.status>1">{{itemSyncDetail.syncDetail.state2.speed}}</span></span>
        </div>
          <div class="detail-three" style="position:relative;top:5px;" v-if="itemSyncDetail.syncDetail&&itemSyncDetail.syncDetail.entities" :style="{height:getHeight()}">
        <div class="sync-line" :key="index" v-for="(item ,index) in itemSyncDetail.syncDetail.entities">
            <span class="sync-column-left transfering-file-line" :title="getTitle(item)">
                {{item.fileNode|getCatalog}}\{{item.filename}}
            </span>
            <span v-if="!isVip()">
                 <span class="sync-column-right transfering-file-line upgradeMulti"  v-if="item.rate==-1" @click.stop="switchToPay()">{{$t('language.common.upgradeMulti')}}</span>
                 <span class="sync-column-right transfering-file-line" v-if="item.rate!=-1">{{item.rate}}%</span>
            </span>
            <span v-else>
                 <span class="sync-column-right transfering-file-line"  v-if="item.rate&&item.rate!=-1">{{item.rate}}%</span>
                 <span class="sync-column-right transfering-file-line" v-else >0%</span>    
            </span>
        </div>
    </div>
          <div class="sync-line">
            <div class="icon-util shop-cart shop-cart-position"></div>
            <span class="transfer-line-des" style="line-height:40Px;" v-if="!isVip()">{{$t('language.common.noVip')}}</span>
            <span class="transfer-line-des" style="line-height:40Px;" v-if="isVip()">{{$t('language.common.vipThanks')}}</span>
        </div>
         <div class="sync-line" v-if="!isVip()">
            <button class="upgrade-now" @click.stop="switchToPay()">{{$t('language.common.upgradeNow')}}</button>
        </div>
    </div>

</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import googleAnalyticsUtil from "../../../../js/workspace/google_analytics_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
export default {
    props: ['flag', 'index', 'detailShow', 'itemSyncDetail', 'threadChange'],
    data: function () {
        return {}
    },
    watch: {
        threadChange(newValue, oldValue) {
            this.$forceUpdate();
             
        },
           '$store.state.threadChange': function (newValue, oldValue) {
            this.$forceUpdate();
             let that = this;
             //single-from-collapse-box大界面
             let dom = that.$parent.$parent.$parent.$refs.threadParents.parentElement.parentElement;
               if(this.itemSyncDetail.syncDetail&&this.itemSyncDetail.syncDetail.entities.length){
                var  heightValue = this.itemSyncDetail.syncDetail.entities.length*25 +20;
                var heightThreads = this.$parent.syncItem.sources.length*52;
                if(!this.isVip()){
                dom.style.height = heightThreads+heightValue +260  + 150 + 'px ';
                that.$parent.$parent.$parent.$refs.threadParents.style.height = heightThreads+heightValue+260  + 150 + 'px ';
                }else{
                 dom.style.height = heightThreads+heightValue +200  + 150 + 'px ';
                that.$parent.$parent.$parent.$refs.threadParents.style.height = heightThreads+heightValue+200  + 150 + 'px ';
                }
               }else{
                 var heightThreads = this.$parent.syncItem.sources.length*52;
                 if(!this.isVip()){
                 dom.style.height = 260 +heightThreads + 150 + 'px ';
                 that.$parent.$parent.$parent.$refs.threadParents.style.height = 260 +heightThreads + 150 + 'px ';
                 }else{
                  dom.style.height = 200 +heightThreads + 150 + 'px ';
                 that.$parent.$parent.$parent.$refs.threadParents.style.height = 200 +heightThreads + 150 + 'px ';
                 }
              }
            this.$parent.$forceUpdate();
            if(this.$parent.showTaskStatus){
            this.$parent.showTaskStatus();
            }
        }
    },
    methods: {
        getTitle(item){
           var title;
           title=commonUtils.getCatalog(item.fileNode);
           title = title +'\\'+item.filename;
           return title;
        },
          switchToPay() {
            googleAnalyticsUtil.pay1(this,"threads");
            commonUtils.switchToPay();
        },
        getHeight(){
            let that = this;
            var heightValue = 0;
            if(this.itemSyncDetail.syncDetail&&this.itemSyncDetail.syncDetail.entities.length){
               heightValue = this.itemSyncDetail.syncDetail.entities.length*25 +20;
               return heightValue+'px';
            }
            return heightValue+'px';
        },
            isVip() {
            let flag = commonUtils.isVip();
            return flag;
        },
       showHaveDoneStatus(syncItem){
        let flag=true;
          if(syncItem.syncDetail.state2 && syncItem.syncDetail.state2.response ){
           if(!isNaN(syncItem.syncDetail.state2.response)){
               flag=false;
              return flag;
           }
        }
        return flag;
    },
    showStatus(syncItem){
     //0.显示counting状态 1.waiting状态 2.running状态  3.显示进度状态 4.取消状态 5.部分成功状态  6.失败状态 7.成功状态
     let flag;
     // 任务必须完成
     if(syncItem.syncDetail.state2.percent==100||this.showHaveDoneStatus(syncItem)||(syncItem.percent==100 && (syncItem.status=='Done'||syncItem.status=='Normal'))){
        //4.取消状态
         if (syncItem.status == 'Done'  && (syncItem.result == 'cancel'||(syncItem.syncDetail.state2&&syncItem.syncDetail.state2.response&&syncItem.syncDetail.state2.response=='cancel'))) {
            flag = 'threadCancel';
             return flag;
          }
        //详情存在情况下的5部分成功状态   //6失败状态
        if(syncItem.syncDetail.state2){
            if(syncItem.syncDetail.state2.errorList){
            if(syncItem.syncDetail.state2.errorList.length){
               if((syncItem.syncDetail.state2.errorList.length/syncItem.syncDetail.state2.totalFileCount)*100<20){
                 flag='particalStatus';
                 return flag;
               }else{
                  flag = 'threadFailure';
                  return flag;
               }
            }else{ //7. 成功状态
                if(syncItem.syncDetail.state2.percent==100){
                     flag='threadSuccess';
                     return flag;    
                }
            }
           }else{
                if(syncItem.syncDetail.state2.percent==100 ||syncItem.percent==100 ||(syncItem.status=='Normal'&&syncItem.result=='success')){
                     flag='threadSuccess';
                     return flag;    
                }
                 //部分成功状态
                 if(syncItem.result == 'error'){
                      if((syncItem.errorFileCount/syncItem.totalFileCount)*100<20){
                     flag='particalStatus';
                     return flag;
                   }else{
                    flag = 'threadFailure';
                     return flag;
                 }
                 }
           }
        }else{  //5部分成功状态   //6失败状态
        if(syncItem.status=='Done'){
            if(syncItem.syncDetail.state2.errorFileCount){
                if((syncItem.syncDetail.state2.errorFileCount/syncItem.syncDetail.state2.totalFileCount)*100<20){
                flag='particalStatus';
                return flag;
                }else{
                flag = 'threadFailure';
                return flag;
               }
            }else{ //7. 成功状态
                 if(syncItem.status!='Running'&&syncItem.status!='Waiting'&&syncItem.result!='error'){
                     flag='threadSuccess';
                     return flag;           
                 }
            }
           }
         }
     }else{//任务内存满了在运行过程中取消
        if(syncItem.syncDetail.state2&&syncItem.syncDetail.state2.runningStatus == -1){
             flag = 'threadCancel';
             return flag;
        }
         if(syncItem.syncDetail.state2){
            if(syncItem.syncDetail.state2.errorList){
            if(syncItem.syncDetail.state2.errorList.length){
               if((syncItem.syncDetail.state2.errorList.length/syncItem.syncDetail.state2.totalFileCount)*100<20){
                 flag='particalStatus';
                 return flag;
               }else{
                  flag = 'threadFailure';
                  return flag;
               }
            }
         }
         }


     }
     return flag;

    }
    }
}
</script>

<style scoped>
.sync-detail {
    width: 100%;
    height: 190px;
    /*no*/
    font-size: 12px;
    /*no*/
    line-height: 20px;
    /*no*/
    color: #6f7886;
    box-sizing: border-box;
    padding: 10px 20px 16px 20px;
    /*no*/
}

.sync-title {
    font-size: 16px;
    /*no*/
    font-weight: bold;
    color: #000;
}

.sync-detail-one {
    width: 100%;
    height: 53px;
    /*no*/
    margin: 15px 0px 16px 0px;
    /*no*/
}

.transfering-file-line {
    height: 25px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.detail-three {
    width: 100%;
    height: 35px;
    /*no*/
    margin-bottom: 16px;
    /*no*/
}

.sync-detail-two {
    width: 100%;
    height: 70px;
    /*no*/
    margin: 10px 0px 16px 0px;
    /*no*/
}

.sync-line {
    width: 100%;
    float: left;
}

.sync-column-left {
    width: 38%;
    float: left;
}

.sync-column-right {
    width: 54%;
    float: left;
}

.sync-all-line {
    width: 100%;
    height: 20px;
    /*no*/
}

.team-top{
    position: relative;
    top: -8Px;
}
.team-top1{
    position: relative;
    top: -9Px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tabs_businessThreads_detail.vue